import { memo } from 'react';
import { FetchDataToIntegrationServerFromAgentForm } from './components/FetchDataToIntegrationServerFromAgentForm';
import { MinimalCard } from 'components/styled';

const FetchDataToIntegrationServerFromAgentCard: React.FC<{
  shouldShowWarningBeforeSubmission?: boolean; // only show warning when on csm tool page
}> = ({ shouldShowWarningBeforeSubmission = false }) => {
  return (
    <MinimalCard sx={{ height: '100%' }}>
      <FetchDataToIntegrationServerFromAgentForm
        shouldShowWarningBeforeSubmission={shouldShowWarningBeforeSubmission}
      />
    </MinimalCard>
  );
};

export default memo(FetchDataToIntegrationServerFromAgentCard);
